import { isValidDomain } from './misc';

export const isValidGSCProperty = (val: string) => {
  const isHTTP = /^https?:\/\//.test(val);
  const isDomainLevel = /^sc-domain:/.test(val);
  const domain = val.replace(/https?:\/\/|sc-domain:/, '');
  return (isHTTP || isDomainLevel) && isValidDomain(domain);
};

export const isValidGoogleAdsID = (val: string) => {
  return val.trim().replace(/-/g, '').length === 10;
};

// Ensure valid ID value on input blur
export const onBlurValidateGoogleAdsID = (
  evt: React.FocusEvent<HTMLInputElement>
) => {
  const GA_ID_ERR_MSG = 'Must be a valid 10-digit ID.';
  const { value } = evt.currentTarget;
  const val = value.trim().replace(/-/g, '');

  if (val.length !== 10) {
    evt.currentTarget.setCustomValidity(GA_ID_ERR_MSG);
  } else {
    if (evt.currentTarget.validationMessage === GA_ID_ERR_MSG) {
      evt.currentTarget.setCustomValidity('');
    }
  }
};

export function isValidStringValue(value: string): boolean {
  const trimmed = value.trim();

  if (!trimmed) return false;

  const regex = /^[a-zA-Z0-9_](-?_?[a-zA-Z0-9_])*$/;
  return regex.test(trimmed);
}
